import { Component, OnInit } from '@angular/core';
import { CoreService } from '../../../service/core.service';


@Component({
  selector: 'app-ledger-dash',
  templateUrl: './ledger-dash.component.html',
  styleUrls: ['./ledger-dash.component.css']
})
export class LedgerDashComponent implements OnInit {
  up: any;

  constructor(private coreService: CoreService) { }

  ngOnInit() {
    this.up = this.coreService.getUserPrivilage();

  }

}
